export default "__VITE_ASSET__DWnSP0IR__"